<script>
  import { _ } from 'svelte-i18n'
  import { modals, user, user_subscription } from '../../stores'
  import Fieldset from '../../elements/Fieldset.svelte'
  import Label from '../../elements/Label.svelte'
  import Button from '../../elements/Button.svelte'
  import Modal from '../../elements/Modal.svelte'
  import ButtonGroup from '../../elements/ButtonGroup.svelte';
  import SubscriptionSelectedPlan from '../SubscriptionSelectedPlan.svelte';
  import { refreshUserSubscription } from '../../services/user';

  let modal_id = 'accountInfo'
  let can_refresh = false
  let simple_valid_until

  $: if ($user) {
    simple_valid_until = new Date($user.valid_until.replace(" ", "T")).toString().substring(4, 15)
  }

  function openAccountManagement(section = '') {
    // Check if we have a pre-authenticated link and if it's not expired
    const now = new Date()
    const linkExpiry = $user.account_management_link?.accounts?.[0]?.expires ? new Date($user.account_management_link.accounts[0].expires) : null
    const linkUrl = $user.account_management_link?.accounts?.[0]?.url
    
    if (linkExpiry && now < linkExpiry && linkUrl) {
      window.open(linkUrl + '#/' + section, '_blank')
    } else {
      // Fallback to generic URL if no valid pre-authenticated link
      window.open('https://wordmarkit.onfastspring.com/account', '_blank')
    }

    // We start a routine to refresh the subscription data every 5 seconds
    // to update modal content if user changes any details
    can_refresh = true
    refreshSubscriptionData()
  }
  
  async function refreshSubscriptionData() {
    if(!$user || !$user.subscription_id) return
    
    try {
      await refreshUserSubscription($user.subscription_id)
      if(can_refresh) window.setTimeout(() => refreshSubscriptionData(), 5000)
    } catch (error) {
      console.error('Error refreshing subscription data:', error)
      // Stop polling if there's an error
      can_refresh = false
    }
  }
</script>

<Modal id={modal_id} on:modalClosed={()=>can_refresh=false}>
  <span slot="header">
    { $_('modals.accountInfo.title')}
  </span>
  <span slot="content">
    <Fieldset>
      <Label>{$_('user.name')}</Label>
      <b>{$user.full_name}</b><br>
      <b>{$user.email}</b>
    </Fieldset>

    {#if $user_subscription}
      <SubscriptionSelectedPlan 
        on:changePaymentMethod={() => openAccountManagement('payment')} 
        on:changeSubscription={() => openAccountManagement('subscriptions')}
        on:upgradeToBusiness={() => modals.open('upgrade_to_business')}
      />
    {:else}
      <Fieldset>
        <Label>{$_('user.validUntil')}</Label>
        <b>{simple_valid_until}</b>
        {#if $user.expired}
          <b class="expired">({ $_('app.expired')})</b>
          <div class="buttonWrapper">
            <Button kind="accent-orange" on_fill={true} on:click={() => modals.open('buy')}>
              See {@html $_('buttons.plansAndPricing')}
            </Button>
          </div>
        {/if}
        <p>
          Access your invoices and purchase history on our account management page.
        </p>
      </Fieldset>
    {/if}
    <ButtonGroup>
      <Button on:click={() => openAccountManagement()} kind="default">{$_('buttons.accountManagement')}</Button>
      <Button kind="outline" on:click={() => {modals.close(); can_refresh=false}}>{$_('buttons.close')}</Button>
    </ButtonGroup>

  </span>
</Modal>

<style>
  p {
    margin-top: 2rem;
  }
  .expired {
    color: var(--c-danger);
  }
  b {
    font-variant-numeric: lining-nums;
  }
  .buttonWrapper {
    margin: 1rem 0 3rem;
  }
</style>